/**
 * @generated SignedSource<<fe541bc54cf4c4037c47970fb8d7de4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CodepushSeverityEnum = "tier1" | "tier2" | "tier3" | "%future added value";
export type CodepushVersionStatusEnum = "production" | "staging" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CodepushVersionConnectionDataTable_codepushVersionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly created: any;
      readonly id: string;
      readonly severity: CodepushSeverityEnum;
      readonly status: CodepushVersionStatusEnum;
      readonly targetBinaryVersion: string;
      readonly title: string;
      readonly version: number;
      readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionStatusLabel_codepushVersion">;
    };
  }>;
  readonly " $fragmentType": "CodepushVersionConnectionDataTable_codepushVersionConnection";
};
export type CodepushVersionConnectionDataTable_codepushVersionConnection$key = {
  readonly " $data"?: CodepushVersionConnectionDataTable_codepushVersionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionConnectionDataTable_codepushVersionConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CodepushVersionConnectionDataTable_codepushVersionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CodepushVersionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CodepushVersion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CodepushVersionStatusLabel_codepushVersion"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "targetBinaryVersion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "severity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CodepushVersionConnection",
  "abstractKey": null
};

(node as any).hash = "515d6c2edb40bbbd8234428de4c63324";

export default node;
